import styled from "styled-components";
import { Container as SobreTranscricao } from "../SobreTranscricao/styles";

export const Container = styled.ol`
  display: flex;
  flex-direction: column;
  gap: 16px;
  list-style: none;
  margin: 16px 0;
  padding: 0;
`;

export const Linha = styled.li`
  display: flex;
  gap: 12px;

  .ponto {
    flex: 0 0 12px;
    width: 12px;
    height: 12px;
    margin-top: 6px;
    border-radius: 50%;
    background: var(--principal-50);
  }

  .ponto.atual {
    background: #fff;
    border: 3px solid var(--principal-50);
  }

  > div {
    min-width: 0;
  }

  strong {
    font-size: 16px;
    line-height: 24px;
    color: var(--cinza-100);
  }

  p {
    font-size: 14px;
    line-height: 20px;
    color: var(--cinza-70);
    margin: 2px 0 0;
  }
`;

// Mesma caixa do "Sobre a transcrição", em amarelo.
export const Aviso = styled(SobreTranscricao)`
  margin: 16px 0 0;
  background: var(--atencao-10);
  border-left-color: var(--atencao-50);
`;
